import { Component, Inject } from '@angular/core';
import {
    CookieService,
    IMenu,
    LocalStorageService,
    PERMISSOES_SERVICE_TOKEN,
    PermissoesService
} from '@sbt-suite/components';
import { environment } from 'src/environments/environment';
import { menuRoles, rolesPersonalizadas } from './core/constants/roles';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    MODE = environment.MODE;
    URL_LOGIN = environment.URL_LOGIN;
    URL_LOGOUT = environment.URL_LOGOUT;

    menuItens: IMenu[] = [
        {
            label: '',
            roles: menuRoles.itensMenu.home.roles,
            itens: [
                {
                    label: 'Home',
                    icone: 'home',
                    link: '/home',
                    roles: Object.values(menuRoles.itensMenu.home.home).flat()
                }
            ]
        },
        {
            label: 'Fornecedor',
            roles: menuRoles.itensMenu.home.roles,
            itens: [
                {
                    label: 'Fornecedor',
                    icone: 'local_shipping',
                    link: '/fornecedor',
                    roles: Object.values(menuRoles.itensMenu.fornecedor.fornecedor).flat()
                },
                {
                    label: 'Regularização',
                    icone: 'list_alt',
                    link: '/regularizacao',
                    roles: Object.values(menuRoles.itensMenu.fornecedor.regularizacao).flat()
                }
            ]
        },
        {
            label: 'Dados Bancários',
            roles: menuRoles.itensMenu.home.roles,
            itens: [
                {
                    label: 'Atualização de Dados Bancário',
                    icone: 'account_balance',
                    link: '/dados-bancarios',
                    roles: rolesPersonalizadas.compras.visualizar
                }
            ]
        },
        {
            label: 'Parâmetros',
            roles: menuRoles.itensMenu.parametros.roles,
            itens: [
                {
                    label: 'Condição de Pagamento',
                    icone: 'credit_card',
                    link: '/parametros/condicao-pagamento',
                    roles: Object.values(menuRoles.itensMenu.parametros.condicaoPagamento).flat()
                },
                {
                    label: 'Tipo de Serviço',
                    icone: 'handyman',
                    link: '/parametros/tipo-servico',
                    roles: Object.values(menuRoles.itensMenu.parametros.tipoServico).flat()
                },
                {
                    label: 'Tipo de Empresa',
                    icone: 'assignment',
                    link: '/parametros/tipo-empresa',
                    roles: Object.values(menuRoles.itensMenu.parametros.tipoHomologacao).flat()
                }
            ]
        }
    ];

    constructor(
        @Inject(PERMISSOES_SERVICE_TOKEN) private _permissoesService: PermissoesService,
        private _cookie: CookieService,
        private _localStorage: LocalStorageService
    ) {
        _permissoesService.initPermissoes();
    }

    ngOnInit() {}

    async logout(event: boolean) {
        if (event) {
            try {
                this.clearCookie();
                this._localStorage.clear();
                window.open(this.URL_LOGOUT, '_self');
            } catch (error) {
                console.error(error);
            }
        }
    }

    private clearCookie() {
        let domain = '';
        if (this.MODE == 'dev' || this.MODE == 'prod') {
            domain = 'tvsbt.com.br';
        }
        this._cookie.delete('access_token', '/', domain);
        this._cookie.delete('refreshToken', '/', domain);
    }
}
